import type { ReactNode } from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import Stack from '@mui/material/Stack';

import type { Or2ButtonProps } from '../button/Or2Button';
import { Or2Button } from '../button/Or2Button';

import type { Or2DialogProps } from './Or2Dialog';
import { Or2Dialog } from './Or2Dialog';

export interface ConfirmDialogProps extends Omit<Or2DialogProps, 'title'> {
  ariaLabel?: string;
  titleText?: ReactNode;
  innerText?: ReactNode;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  confirmButtonProps?: Or2ButtonProps;
  onConfirm: () => void;
}

export function ConfirmDialog({
  open,
  ariaLabel,
  titleText,
  innerText,
  cancelText,
  confirmText,
  loading,
  onClose,
  onConfirm,
  confirmButtonProps,
  ...other
}: ConfirmDialogProps) {
  return (
    <Or2Dialog
      ariaLabel={`${ariaLabel}-confirm`}
      open={open}
      small
      hideCloseButton
      loading={loading}
      title={titleText || 'Are you sure?'}
      actions={
        <Stack direction="row" spacing={0.5}>
          <Or2Button
            disabled={loading}
            onClick={onClose}
            color="secondary"
            size="small"
          >
            {cancelText || 'Cancel'}
          </Or2Button>
          <Or2Button
            disabled={loading}
            onClick={onConfirm}
            color="primary"
            size="small"
            {...confirmButtonProps}
          >
            {confirmText || 'Ok'}
          </Or2Button>
        </Stack>
      }
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      {...other}
    >
      <DialogContentText
        component="div"
        id={`${ariaLabel}-confirm-dialog-description`}
      >
        {innerText || null}
      </DialogContentText>
    </Or2Dialog>
  );
}
